// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__3eHyn","link":"Logo_link__rgCR4","logo":"Logo_logo__22AUk","line":"Logo_line__3p3Bj","circle":"Logo_circle__kj2BF","title":"Logo_title__ZCJai"};